// DashboardInteractionEditContext.tsx
//
// "Edit interactions" (plan 2026-10-05 dashboard interactivity, B5; Power BI's
// gesture): in edit mode an author picks a tile, and every other tile on the
// tab shows whether a click on that tile filters it. Provided by Insights only
// to a builder on a dashboard that may carry targets (not a managed one, v1);
// null everywhere else, which hides the menu entry and every toggle.
import { createContext, useContext } from "react";
import type { DashboardItemDTO, InteractionTargets } from "@/api/dashboards";

export type InteractionEdit = {
  /** The tile whose clicks are being scoped. */
  source: DashboardItemDTO;
  /** Its stored targets. */
  targets: InteractionTargets;
  /** The dimensions a click on the source filters on. */
  clickDimensions: ReadonlyArray<{ key: string; label: string }>;
  /** A write is in flight; toggles wait for it. */
  saving: boolean;
};

export interface DashboardInteractionEditContextValue {
  editing: InteractionEdit | null;
  start: (itemId: string) => void;
  stop: () => void;
  /** Switch one tile on or off as a target of the source. */
  setTargeted: (target: DashboardItemDTO, on: boolean) => void;
  /** Back to the default: every tile that can take the filter. */
  reset: () => void;
}

const DashboardInteractionEditContext = createContext<DashboardInteractionEditContextValue | null>(null);

export const DashboardInteractionEditProvider = DashboardInteractionEditContext.Provider;

export function useDashboardInteractionEdit(): DashboardInteractionEditContextValue | null {
  return useContext(DashboardInteractionEditContext);
}
